module.exports = __webpack_public_path__ + "static/media/chet_faker_2.604c9638.jpg";